if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.initSpinner();
      this.loadedImages = new Set();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      if (opener.classList.contains('productGallery__featuredButton') || opener.classList.contains('productGallery__contentButton')) {
        this.loadHighResImages();
      } else {
        this.showActiveMedia();
      }
    }

    initSpinner() {
      this.spinner = document.createElement('div');
      this.spinner.classList.add('loading-overlay__spinner', 'hidden');
      this.spinner.innerHTML = `
        <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
        </svg>`;
      this.querySelector('.product-media-modal__content').appendChild(this.spinner);
    }

    showSpinner() {
      this.spinner.classList.remove('hidden');
    }

    hideSpinner() {
      this.spinner.classList.add('hidden');
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }

    showActiveMediaZoom() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.scrollIntoView();
    }
    
    async loadHighResImages() {
      const modalContent = this.querySelector('.product-media-modal__content');
      modalContent.classList.add('loading');
      this.showSpinner();

      const featuredImage = document.querySelector('.productGallery__featuredImage');
      const images = document.querySelectorAll('.productGallery__contentItemImage');
      const allImages = featuredImage ? [featuredImage, ...images] : [...images];
      
      // Create an array of promises for loading each image
      const imagePromises = allImages.map(image => {
        const dataMediaId = image.getAttribute('data-media-id');
        return this.appendHighResImage(modalContent, image, dataMediaId);
      });
    
      // Wait for all images to load
      await Promise.all(imagePromises);
    
      // Once all images are loaded, hide the spinner and perform any additional actions
      this.hideSpinner();
      this.showActiveMediaZoom();
    }

    appendHighResImage(modalContent, image, dataMediaId) {
      return new Promise((resolve, reject) => {
        const highResImageSrc = image.getAttribute('data-zoom-image');
        if (highResImageSrc && !this.loadedImages.has(highResImageSrc)) {
          const modalImage = new Image();
          modalImage.src = highResImageSrc;
          modalImage.alt = image.alt;
          modalImage.classList.add('global-media-settings', 'global-media-settings--no-shadow');
          modalImage.width = 850;
          modalImage.height = 850;
          const srcBase = highResImageSrc.split('&')[0];
          modalImage.srcset = `
            ${srcBase}&width=550 550w, 
            ${srcBase}&width=1100 1100w, 
            ${srcBase}&width=1445 1445w, 
            ${srcBase}&width=1680 1680w, 
            ${srcBase}&width=2048 2048w`;
          modalImage.sizes = '(min-width: 750px) calc(100vw - 22rem), 1100px';
           if (dataMediaId) {
            modalImage.setAttribute('data-media-id', dataMediaId); // Set data-media-id
          }
          modalImage.onload = () => {
            // Once loaded, hide the spinner
            this.hideSpinner();
            // And add the image URL to the cache
            this.loadedImages.add(highResImageSrc);
            resolve();
          };
          modalImage.onerror = reject;
          modalContent.appendChild(modalImage);
        } else {
          resolve(); // Resolve immediately if image is already loaded or src is missing
        }
          });

      }

  });
}
